export default String.raw`
button {
    font: inherit;
    color: inherit;
    background: none;
    border: none;
    cursor: pointer;
  }


.keyboard-focus {
    outline-style: solid !important;
    outline-color: $focusVisibleColor !important;
    outline-width: 1px !important;
    outline-offset: 2px !important;
}

input:focus:not(.keyboard-focus),
select:focus:not(.keyboard-focus),
textarea:focus:not(.keyboard-focus),
button:focus:not(.keyboard-focus),
a:focus:not(.keyboard-focus) {
    outline: none !important;
    outline-color: transparent !important;
    box-shadow: none !important;
}

*:focus-visible {
    outline-style: solid !important;
    outline-color: $focusVisibleColor !important;
    outline-width: 1px !important;
    outline-offset: 2px !important;
}

*:focus:not(:focus-visible):not(.keyboard-focus) {
    outline: none !important;
}

[data-using-keyboard="true"] :focus {
    outline-style: solid !important;
    outline-color: $focusVisibleColor !important;
    outline-width: 1px !important;
    outline-offset: 2px !important;
}

.select {
    position: relative;
    cursor: pointer;
    user-select: none;

    select {
        display: none;
    }

    &__input {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .selected-js {
            overflow: hidden;
            word-break: break-all;
            padding-right: 4px;
        }

        svg {
            flex-shrink: 0;
        }
    }

    &.opened-select-js {
        .select {
            &__input {
                svg {
                    rotate: 180deg;
                }
            }

            &__options {
                display: block;
            }
        }
    }

    &__options {
        display: none;
        position: absolute;
        width: 100%;
        z-index: 999;
        overflow-y: auto;
        background-color: $lightestColor;
        border-radius: 5px;
        -webkit-box-shadow: 2px 0px 8px 0px rgba(0, 0, 0, 0.12);
        -moz-box-shadow: 2px 0px 8px 0px rgba(0, 0, 0, 0.12);
        box-shadow: 2px 0px 8px 0px rgba(0, 0, 0, 0.12);
        max-height: 40px * 4;

        &::-webkit-scrollbar {
            width: 4px;
            border-radius: 50%;
        }

        &::-webkit-scrollbar-track {
            background-color: rgba(#959595, 0.35);
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(#959595, 0.5);
            outline: none;
            border-radius: 2px;

            &:hover {
                background-color: #959595;
            }
        }

        & > * {
            overflow: hidden;
            white-space: inherit;
            text-overflow: ellipsis;
            width: auto;
            cursor: pointer;
            padding: 10px 16px;
            @include body-1-regular;

            &.focused-option-js {
                background-color: $lighterColor;
            }

            &:hover {
                background-color: $lighterColor;
            }
        }
    }
}

// dialog
.dialog {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    border-radius: 12px;
    background: #fff;
    border: none;
    color: inherit;
    position: fixed;
    overflow: hidden;
    opacity: 0;
    box-shadow: 0 0 0.2rem 0 rgba(0, 0, 0, 0.2);
    transition: opacity 0.3s ease, transform 0.3s ease;
  
    &::backdrop {
        background: rgba(46, 46, 46, 0.20);
    }

    &.info {
        align-items: unset;
    }
  
    &__header {
        display: flex;
        padding: 32px 32px 0px 32px;
        width: 100%;
        align-self: flex-start;
        align-items: center;
        flex: 0 0 auto;
        justify-content: space-between;
    }
  
    &__close {
        display: flex;
        align-content: center;
        justify-content: center;
        align-items: center;
        padding: 0;
        margin: 0;
        background: none;
        border: none;
        cursor: pointer;
  
        svg {
            fill: #959595;
        }
    }
  
    &__content {
        display: flex;
        width: 100%;
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: flex-start;
        flex: 1 1 auto;
        overflow: hidden;
    }
  
    &__actions {
        display: flex;
        flex-wrap: wrap;
        margin-top: auto;
        flex: 0 0 auto;
        align-items: center;
        align-self: flex-end;
    }
  
    &[open] {
        display: flex;
        animation: slideIn 0.3s forwards;
    }
  
    @keyframes slideIn {
        from {
            transform: translateY(100%);
            opacity: 0;
        }
  
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
}

.modal-opened{
    overflow: hidden;
}

.popup-background{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(46, 46, 46, 0.20);
    z-index: 1002;
}
  
.popup{
    max-width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 12px;
    padding: 30px;
    background-color: #fff;
    color: #2E2E2E; 
    &__header{
        display: flex;
        justify-content: space-between;
        gap: 30px;
        .title{
            font-size: 24px;
            font-weight: 500;
            line-height: 32px;
        }
        svg{
            width: 24px;
            height: 24px;
            fill: #959595;
            cursor: pointer;
        }
    }
    &__content{
        margin-top: 15px;
        overflow-y: auto;
        max-height: 70vh;
    }
    &.rendered-dialog {
        display: flex;
        flex-direction: column;
        position: static;
        padding: 32px 16px 32px 32px;
        width: 100%;
        max-width: unset;
        transform: none;
        overflow: hidden;
        .popup__content {
            max-height: unset;
            overflow-y: auto;
            padding-right: 16px;
        }
        .popup__buttons {
            padding-right: 16px;
        }
    }
}

.thresholds-popup{
    min-width: 300px;
    .popup__content{
        margin-top: 10px;
        .name{
            font-size: 14px; 
            line-height: 20px; 
        }
        .thresholds{
            margin-top: 30px;
            &__row{
                display: flex;
                justify-content: space-between;
                margin-bottom: 8px;
                font-weight: 500;
                font-size: 14px; 
                line-height: 20px; 
                &:first-child{
                    margin-bottom: 16px;
                }
                &:last-child{
                    margin: 0;
                }
            }
        }
    }
}

.popup-info {
    display: none;
    border-radius: 10px;
    border: none;
    color: inherit;
    position: fixed;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    max-width: 300px;
    width: fit-content;
    right: 0;
    bottom: 0;
    z-index: 99999;
    overflow: hidden;
    margin: 0 10px 10px 10px;

    p {
        color: #4A4A4A;
    }

    &__close {
        position: absolute;
        padding: 0;
        margin: 0;
        background: none;
        border: none;
        cursor: pointer;
        top: 16px;
        right: 16px;

        svg {
            fill: #959595 !important;
            width: 16px;
            height: 16px;
        }
    }

    &__content {
        padding: 16px;

        h2 {
            display: flex;
            align-items: center;
            column-gap: 7px;
            @include body-1-semi-bold;
            margin-bottom: 4px;
        }

        p {
            padding-right: 15px;
        }
    }

    @keyframes progress-bar {
        from {
            width: 0;
        }

        to {
            width: 100%;
        }
    }

    &__bar {
        width: 100%;
        height: 4px;

        &-progress {
            width: 0;
            height: 4px;
            opacity: 0.5;
            animation-fill-mode: forwards;
            animation-duration: 4s;
            animation-name: progress-bar;
        }
    }

    $parent: &;

    &.err {
        background-color: #FDF4F5;

        #{$parent}__bar {
            background-color: $dangerColor;

            &-progress {
                background-color: #FDF4F5;
            }
        }
        
        svg {
            fill: #DA2442;
        }
    }

    &.warn {
        background-color: #FFF2DA;

        #{$parent}__bar {
            background-color: $warnColor;

            &-progress {
                background-color: #FFF2DA;
            }
        }

        svg {
            fill: #F5A623;
        }
    }

    &.msg {
        background-color: #E5FFED;  // Required light succes color variable

        #{$parent}__bar {
            background-color: $successColor;

            &-progress {
                background-color: #E5FFED;
            }
        }

        svg {
            fill: #008945;
        }
    }

    &.info {
        background-color: #EAF4FF;  // Required light info color variable

        #{$parent}__bar {
            background-color: #253A75;

            &-progress {
                background-color: #EAF4FF;
            }
        }

        svg {
            fill: #253A75;
        }
    }
}

.popup-in-form {
    position: fixed;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    display: flex;
    min-height: 40px;
    padding-left: 16px;
    align-items: center;
    gap: 16px;
    border-radius: 5px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.20);
    margin-bottom: 24px;
    width: auto;
    max-width: 100%;
    white-space: nowrap;
    background-color: #fff;
    
    &__close {
        display: flex;
        background: none;
        border: none;
        cursor: pointer;
        padding: 8px 16px;
        margin-left: auto;
        align-self: flex-start;

        svg {
            fill: #959595 !important;
            width: 16px;
            height: 16px;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        flex: 1 0 0;
        
        .header {
            display: flex;
            align-items: center;
            gap: 16px;
        }

        p {
            padding: 8px 0px;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px;
            color: #2E2E2E;
        }
    }

    &.err {
        background-color: #FDF4F5;
        border-left: 5px solid #DA2442;

        svg {
            fill: #DA2442;
        }
    }

    &.warn {
        background-color: #FFF2DA;
        border-left: 5px solid #F5A623;

        svg {
            fill: #F5A623;
        }
    }

    &.msg {
        background-color: #E5FFED;
        border-left: 5px solid #008945;

        svg {
            fill: #008945;
        }
    }

    &.info {
        background-color: #EAF4FF;
        border-left: 5px solid #253A75;

        svg {
            fill: #253A75;
        }
    }
}

.technical-break {
    margin: 110px 130px 0 130px;
    display: flex;
    flex-direction: row;
    gap: 64px;
    align-items: center;
    justify-content: center;

    .content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 40px;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px;

        &__info {
            display: flex;
            flex-direction: column;
            gap: 24px;
            max-width: 480px;
            margin-top: 24px;

            .description {
                color: $labelsColor;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
            }
        }

        &__mobile {
            display: none;
        }
    }

    &__image {
        display: block;
    }
}

.cookie-message-opener {
    position: fixed;
    bottom: 20px;
    left: 20px;
    width: 50px;
    height: 50px;
    z-index: 998;
    background: $primaryColor;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);
    cursor: pointer;
    transition: transform 0.3s linear, box-shadow 0.3s linear;
    &:hover {
      transform: rotate(-90deg) scale(1.02);
      box-shadow: -2px 2px 8px rgba(0, 0, 0, 0.7);
    }
    .cookie-message-opener-icon {
      width: 70%;
      height: 70%;
      fill: $bgColor;
    }
}

.notice-container-background {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(46, 46, 46, 0.20);
    z-index: 1001;
    display: flex;
    justify-content: center;
    align-items: center;
}

.notice-container {
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    z-index: 999;
    padding: 32px;
    background-color: $bgColor;
    border-radius: 12px;
    &.top-notice {
        top: 0;
        border-radius: 0 0 12px 12px;
        box-shadow: 0 0 4px 0 rgba(46, 46, 46, 0.20);
    }
    &.bottom-notice {
        bottom: 0;
        border-radius: 12px 12px 0 0;
        box-shadow: 0 0 4px 0 rgba(46, 46, 46, 0.20);
    }
    &.popup-notice {
        max-width: 768px;
        margin: auto;
    }
    &__title {
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
        margin-bottom: 24px;
        color: $primaryColorFont;
    }
    &__message {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 24px;
        color: $primaryColorFont;
    }
    &__btn-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    &__btn {
        &.secondary-action-button {
            border-color: transparent;
            padding: 8px 0;
            margin-right: 24px;
        }
    }
    &__close {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 32px;
        right: 32px;
        cursor: pointer;
    }
}

.cookie-container-background {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    background: rgba(46, 46, 46, 0.20);
    display: flex;
    align-items: center;
    justify-content: center;
}

.cookie-container {
    width: 100%;
    max-width: 768px;
    background-color: $bgColor;
    padding: 32px;
    color: $primaryColorFont;
    border-radius: 12px;
    &__title {
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
    }
    &__box {
        margin-top: 24px;
        overflow-y: auto;
        max-height: 356px;
        &::-webkit-scrollbar {
            width: 4px;
            border-radius: 50%;
        }
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 4px transparent;
        }
        &::-webkit-scrollbar-thumb {
            background-color: rgba(#959595, 0.5);
            outline: none;
            border-radius: 2px;
            &:hover{
                background-color: #959595;
            }
        }
        @-moz-document url-prefix() { 
            padding-right: 12px;
        }
    }
    &__paragraph {
        font-size: 14px;
        line-height: 20px;
    }
    &__link {
        display: inline-block;
        margin: 16px 0;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        color: $primaryColor;

        &:focus-visible {
            outline-offset: -1px !important;
        }
    }
    &__btn-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 24px;
    }
    &__btn {
        &.secondary-action-button {
            border-color: transparent;
            padding: 8px 0;
            margin-right: 24px;
        }
    }
}

.cookie-consent {
    padding: 16px 0;
    font-size: 12px;
    line-height: 16px;
    border-bottom: 1px solid #E7E7E7;
    &:last-of-type {
        border-bottom: none;
    }
    &__wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
    }
    &__title {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
    }
    &__consent {
        position: relative;
        width: 35px;
        height: 12px;
        border-radius: 6px;
        background-color: #959595;
        margin-right: 2px;
        cursor: pointer;
        &::after {
            content: "";
            display: block;
            width: 20px;
            height: 20px;
            position: absolute;
            top: calc(50% - 10px);
            left: 0;
            right: auto;
            background-color: #F3F3F3;
            border-radius: 50%;
            box-shadow: 0 1px 2px 0 rgba(46, 46, 46, 1);
            transform: translateX(0);
            transition: all 0.3s linear;
        }
        &[data-value="granted"] {
            background-color: $lighterColor;
            &::after {
                background-color: $lighterColor;
                transform: translateX(15px);
                transition: all 0.3s linear;
            }
            &[data-name]::after {
                background-color: $primaryColor;
            }
        }

        &:focus-visible {
            outline-offset: 1px !important;
        }
    }
}

.go-to-top-button {
    display: none;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: fixed;
    bottom: 20px;
    right: 5%;
    z-index: 100;
    width: 50px;
    height: 50px;
    border-radius: 12px;
    border: none;
    background-color: $iconColors;
    box-shadow: 1px 1px 4px 0 rgba(46, 46, 46, 0.5);
    transition: background-color 0.3s linear;
    cursor: pointer;
    &:hover {
        background-color: $iconColorsHover;
    }
    svg {
        width: 24px;
        height: 24px;
        transform: rotate(180deg);
        fill: $bgColor;
    }
}

.customer-container-menu {
    display: flex;
    background-color: $bgColor;
    transition: 200ms;
    z-index: 9;
    min-width: max-content;

    &__label,
    &__logout {
      @include body-1-medium;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;

      svg {
        margin-right: 8px;
      }

      &:hover {
        fill: $iconColors;
        color: $iconColors;
      }
    }

    &__header {
      @include h3-headline;
    }

    > ul {
      display: inherit;
      flex-direction: column;
      border-right: 1px solid #d6d6d6;

      > li {
        margin: 0 24px 24px 0;
        width: fit-content;
      }
    }

    .email-container {
      @include body-1-medium;
      width: 220px;

      span {
        word-wrap: break-word;
      }
    }

    .credit-info {
      @include body-1-regular;
      margin-bottom: 24px;

      .data-container {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;

        &__name {
          margin-bottom: 8px;
        }
      }
    }
}

.sign-out-button {
  display: flex;
  align-items: center;
}

.form__input-info.input-info-js.on-label {
    top: 1px;
    font-size: 12px;
    line-height: 16px;
    z-index: 1;
}
`